'use client';
import { lazy, Suspense, forwardRef, useRef, type ComponentProps, type ComponentRef } from 'react';
import { GenericLoader } from '@eliadmin/core/src/components/ui/generic-loader';
export type * from "/tmp/build-258/node_modules/@eliadmin/core/src/components/cart/detail/supplier-map.tsx";

type Props = NonNullable<ComponentProps<typeof import("/tmp/build-258/node_modules/@eliadmin/core/src/components/cart/detail/supplier-map.tsx").SupplierMap>>;
const Deferred = lazy(() => import("@eliadmin/module-original/supplierMap").then(m => ({ default: m.SupplierMap })));
export function SupplierMap(props: Props) {  return <Suspense fallback={<div aria-busy="true" className="flex h-[300px] items-center justify-center"><GenericLoader /></div>}><Deferred {...props} /></Suspense>; }

